export const WEBHOOK_URL = ''
export const WHATSAPP_NUMBER = '17866035862'

export type ProfileType = 'techo' | 'cerca' | 'paso'
export type BlockType = 'estrategia' | 'estructura' | 'tecnologia' | 'empate'

export interface Option {
  text: string
  value: number
}

export interface Question {
  id: number
  block: BlockType
  blockName: string
  text: string
  options: Option[]
}

export const questions: Question[] = [
  {
    id: 1,
    block: 'estrategia',
    blockName: 'BLOQUE 1 — ESTRATEGIA',
    text: 'Cuando piensas en los próximos 12 meses de tu negocio, ¿qué tan clara es la dirección?',
    options: [
      {
        text: 'Tengo total claridad — sé hacia dónde voy y cómo llegar',
        value: 4,
      },
      { text: 'Tengo idea general pero no un plan específico', value: 3 },
      { text: 'Voy reaccionando a lo que aparece semana a semana', value: 2 },
      {
        text: 'No he tenido tiempo de pensar en eso — estoy sobreviviendo el día a día',
        value: 1,
      },
    ],
  },
  {
    id: 2,
    block: 'estrategia',
    blockName: 'BLOQUE 1 — ESTRATEGIA',
    text: 'Si tuvieras que explicar en una frase qué hace tu negocio diferente a la competencia, ¿qué dirías?',
    options: [
      {
        text: 'Tengo un diferenciador claro y comunicable — mis clientes lo reconocen',
        value: 4,
      },
      { text: 'Sé qué me diferencia, pero me cuesta articularlo', value: 3 },
      {
        text: 'Somos parecidos a otros — competimos por precio o servicio',
        value: 2,
      },
      { text: 'Honestamente, no tengo un diferenciador claro', value: 1 },
    ],
  },
  {
    id: 3,
    block: 'estrategia',
    blockName: 'BLOQUE 1 — ESTRATEGIA',
    text: 'Tus decisiones de inversión del último año (contrataciones, herramientas, marketing), ¿respondieron a una estrategia o a la urgencia del momento?',
    options: [
      { text: 'Todas respondieron a una estrategia planificada', value: 4 },
      { text: 'La mayoría fueron estratégicas, algunas reactivas', value: 3 },
      { text: 'Más reactivas que estratégicas', value: 2 },
      { text: 'Casi todas fueron para apagar incendios', value: 1 },
    ],
  },
  {
    id: 4,
    block: 'estrategia',
    blockName: 'BLOQUE 1 — ESTRATEGIA',
    text: '¿Sabes cuáles son los 3 indicadores críticos que determinan la salud real de tu negocio — y los revisas con frecuencia?',
    options: [
      { text: 'Sí, los tengo definidos y los reviso semanalmente', value: 4 },
      { text: 'Los conozco pero no los reviso con disciplina', value: 3 },
      { text: 'Los intuyo pero no los tengo medidos', value: 2 },
      {
        text: 'No tengo métricas claras — me guío por la sensación general',
        value: 1,
      },
    ],
  },
  {
    id: 5,
    block: 'estructura',
    blockName: 'BLOQUE 2 — ESTRUCTURA',
    text: 'Si te desconectas completamente del negocio por una semana, ¿qué pasa?',
    options: [
      {
        text: 'Todo sigue funcionando sin problema — el equipo sabe qué hacer',
        value: 4,
      },
      {
        text: 'Funciona la mayor parte, algunas decisiones me esperan',
        value: 3,
      },
      { text: 'Funciona a medias — varias cosas se frenan', value: 2 },
      { text: 'No puedo desconectarme — todo depende de mí', value: 1 },
    ],
  },
  {
    id: 6,
    block: 'estructura',
    blockName: 'BLOQUE 2 — ESTRUCTURA',
    text: 'Los procesos clave de tu negocio (cómo se atiende un cliente, cómo se cotiza, cómo se entrega), ¿dónde viven?',
    options: [
      { text: 'Documentados, accesibles y el equipo los sigue', value: 4 },
      { text: 'Documentados pero no siempre se siguen', value: 3 },
      { text: 'Están en la cabeza de algunas personas clave', value: 2 },
      { text: 'Viven en mi cabeza — yo los enseño cada vez', value: 1 },
    ],
  },
  {
    id: 7,
    block: 'estructura',
    blockName: 'BLOQUE 2 — ESTRUCTURA',
    text: 'Cuando tu equipo enfrenta una decisión de operación diaria, ¿qué hace?',
    options: [
      {
        text: 'La resuelve aplicando criterios que ya tenemos definidos',
        value: 4,
      },
      {
        text: 'La resuelve la mayoría de veces, consulta las difíciles',
        value: 3,
      },
      { text: 'Consulta casi todo conmigo antes de decidir', value: 2 },
      { text: 'Todo lo que no sea trivial me llega a mí', value: 1 },
    ],
  },
  {
    id: 8,
    block: 'estructura',
    blockName: 'BLOQUE 2 — ESTRUCTURA',
    text: 'Cuando has intentado delegar en tu equipo, ¿cuál ha sido el resultado habitual?',
    options: [
      {
        text: 'Ha funcionado bien — delegan y ejecutan con autonomía',
        value: 4,
      },
      { text: 'Ha funcionado regular — a veces termino retomando', value: 3 },
      {
        text: 'Ha fallado más veces de las que quisiera — termino haciéndolo yo',
        value: 2,
      },
      { text: 'Casi nunca logro delegar — "nadie lo hace como yo"', value: 1 },
    ],
  },
  {
    id: 9,
    block: 'tecnologia',
    blockName: 'BLOQUE 3 — TECNOLOGÍA',
    text: 'De las herramientas tecnológicas que has implementado en el último año (CRM, automatizaciones, IA, etc.), ¿qué tanto se usan realmente?',
    options: [
      { text: 'Todas se usan y han mejorado la operación', value: 4 },
      { text: 'La mayoría se usan con resultados mixtos', value: 3 },
      { text: 'Implementamos varias pero muy pocas se usan', value: 2 },
      { text: 'Tenemos herramientas pagadas que nadie abre', value: 1 },
    ],
  },
  {
    id: 10,
    block: 'tecnologia',
    blockName: 'BLOQUE 3 — TECNOLOGÍA',
    text: 'Cuando decides implementar una nueva herramienta o tecnología, ¿cómo tomas la decisión?',
    options: [
      {
        text: 'Primero defino qué proceso quiero mejorar y qué problema resuelve',
        value: 4,
      },
      {
        text: 'Evalúo varias opciones y elijo la que mejor se ajusta',
        value: 3,
      },
      { text: 'Pruebo lo que recomiendan o lo que está de moda', value: 2 },
      { text: 'Compro por impulso cuando veo algo prometedor', value: 1 },
    ],
  },
  {
    id: 11,
    block: 'tecnologia',
    blockName: 'BLOQUE 3 — TECNOLOGÍA',
    text: '¿Cuántas tareas repetitivas en tu negocio podrían automatizarse pero hoy se hacen manualmente?',
    options: [
      { text: 'Muy pocas — ya automatizamos lo que tenía sentido', value: 4 },
      { text: 'Algunas, pero no es crítico', value: 3 },
      { text: 'Bastantes — sé que podríamos hacerlo mejor', value: 2 },
      { text: 'La mayor parte de la operación es manual', value: 1 },
    ],
  },
  {
    id: 12,
    block: 'tecnologia',
    blockName: 'BLOQUE 3 — TECNOLOGÍA',
    text: 'Cuando piensas en la tecnología dentro de tu negocio, ¿qué sientes?',
    options: [
      { text: 'Es un multiplicador claro de mi operación', value: 4 },
      { text: 'Ayuda, pero no está optimizada', value: 3 },
      { text: 'Me abruma — no sé por dónde empezar a ordenar', value: 2 },
      { text: 'Me genera frustración — más que ayudar, complica', value: 1 },
    ],
  },
]

export const profiles = {
  techo: {
    headline:
      'Tu negocio está operando en el techo — y seguir empujando no va a cambiarlo.',
    analysis: [
      'Lo que describen tus respuestas es un negocio que funciona porque tú lo sostienes. Eso no es un defecto de carácter — de hecho, llegaste hasta aquí precisamente porque tienes la capacidad de sostener. El problema es que esa misma capacidad se convirtió en el límite. El negocio no está fallando: está rindiendo todo lo que puede dar con la estructura actual. Y la estructura actual eres tú.',
      'En este punto, las soluciones convencionales dejan de funcionar. Trabajar más horas ya no mueve la aguja. Contratar a alguien más tampoco, porque sin procesos esa persona va a depender de ti para saber qué hacer. Comprar una herramienta nueva tampoco resuelve, porque sin claridad de qué problema exactamente estás resolviendo, la herramienta se suma al inventario de cosas que nadie usa. Lo que estás sintiendo no es falta de esfuerzo. Es un negocio que llegó al límite de lo que puede dar sin rediseño.',
      'La buena noticia es que esto no es un callejón sin salida. Es una señal clara de que el siguiente nivel requiere una forma distinta de construir — no más de lo mismo con más fuerza. Los dueños que cruzan este techo no lo hacen trabajando el doble. Lo hacen redefiniendo cómo está armado el sistema: qué decisiones viven en el equipo, qué procesos operan sin su presencia, qué tecnología ejecuta lo que antes dependía de que alguien se acordara. Esa transición es concreta, es replicable, y tiene un orden correcto.',
      'Lo que necesitas ahora no es más información general ni más motivación. Necesitas claridad específica sobre los 2-3 puntos de fricción reales de tu operación y el orden correcto para empezar a intervenir. Todo lo demás — estructura, tecnología, equipo — se construye encima de eso.',
    ],
    nextStep:
      'Hablemos directamente. En una conversación de 45-60 minutos identificamos los 2-3 puntos de fricción más críticos de tu operación y definimos el orden correcto para empezar a construir. No es una llamada de ventas. Es una conversación real con claridad al final. Escríbeme por WhatsApp.',
    whatsappMsg:
      'Hola Oscar, hice el diagnóstico y salí en Estás en el techo. Me gustaría hablar contigo.',
  },
  cerca: {
    headline:
      'Estás cerca del techo — hay tiempo para prevenir, no solo para reaccionar.',
    analysis: [
      "Tu negocio tiene cimientos reales. Eso es evidente en tus respuestas: hay dirección, hay procesos que funcionan, hay un equipo que opera con cierta autonomía. No estás en un caos operativo, y eso te pone en una posición ventajosa frente a la mayoría. Pero también hay algo que empieza a mostrar tensión — zonas donde sientes que el negocio depende más de ti de lo que debería, decisiones que siguen pasando por tu mesa cuando no deberían, áreas donde la operación funciona porque 'siempre ha funcionado así' y no porque esté realmente diseñada.",
      'El desafío de esta etapa es específico: los negocios que están cerca del techo tienden a posponer la intervención estructural porque las cosas aún funcionan. No hay urgencia visible. Los clientes siguen llegando, el equipo sigue respondiendo, los números siguen saliendo. Pero esa estabilidad aparente es engañosa. Lo que hoy funciona con esfuerzo aceptable, en 6 a 12 meses — cuando llegue el próximo crecimiento — va a funcionar con esfuerzo insostenible. Y en ese momento, ya no vas a estar previniendo: vas a estar apagando incendios.',
      'La diferencia entre los dueños que cruzan el techo con orden y los que chocan contra él es exactamente esto: los primeros intervinieron antes de que se volviera obligatorio. No esperaron a que la operación se rompiera para construir estructura. Usaron la ventana de tiempo que tenían — la misma ventana en la que tú estás ahora — para identificar los puntos que iban a ceder bajo presión y reforzarlos antes de que la presión llegara.',
      'Esa ventana no dura para siempre. Y la decisión clave no es si vas a necesitar construir estructura — sino si vas a construirla desde la calma o desde la urgencia. Quien construye desde la calma puede elegir qué priorizar. Quien construye desde la urgencia construye lo que puede con lo que tiene.',
    ],
    nextStep:
      'Hablemos directamente por WhatsApp. Identificamos el bloque más débil de tu operación y definimos el plan específico para trabajarlo antes de que el próximo crecimiento lo convierta en un punto de ruptura. Construir desde la calma es una ventaja que no dura para siempre.',
    whatsappMsg:
      'Hola Oscar, hice el diagnóstico y salí en Cerca del techo. Me gustaría hablar contigo.',
  },
  paso: {
    headline:
      'Ya pasaste el techo — ahora la pregunta es cómo escalar sin perder lo que construiste.',
    analysis: [
      'Lo que describen tus respuestas es un negocio con estructura real. Hay dirección estratégica, los procesos viven en el sistema y no solo en tu cabeza, el equipo opera con criterio, y la tecnología está al servicio del negocio — no al revés. Esto no es común, y no es accidente. Llegaste aquí porque en algún momento tomaste decisiones de construcción que la mayoría no toma: documentar procesos cuando todavía no era urgente, definir criterios de decisión antes de que el volumen lo exigiera, implementar tecnología con criterio en lugar de por impulso. Ese trabajo está rindiendo hoy.',
      'El riesgo de esta etapa no es el estancamiento. Es distinto, y por eso más difícil de detectar. Los negocios que ya pasaron el techo operativo suelen enfrentar un problema nuevo: el próximo nivel de crecimiento — más clientes, más equipo, más complejidad, más geografías, más líneas de negocio — introduce variables que el sistema actual no fue diseñado para manejar. Lo que hoy funciona bajo ciertas condiciones puede dejar de funcionar cuando esas condiciones cambien. Y como el sistema está acostumbrado a funcionar, la tentación es asumir que va a seguir funcionando a cualquier escala.',
      'El desafío estratégico real es distinto al que tuviste en etapas anteriores. Antes, el trabajo era construir la estructura que hoy tienes. Ahora, el trabajo es diseñar cómo esa estructura evoluciona sin romperse. Eso significa anticipar qué dimensión del próximo crecimiento va a introducir más complejidad: si es geográfica, si es de producto, si es de equipo, si es de canal. Y significa reforzar las áreas que van a recibir ese impacto antes de que lleguen — no mientras están llegando.',
      'En este nivel, el diferenciador ya no está en sostener la operación. Está en la coherencia. Mantener, a medida que escalas, la claridad estratégica, la calidad operativa y el propósito que te trajo hasta aquí. Los negocios que crecen perdiendo eso terminan siendo exitosos por fuera y desconectados por dentro. Los que crecen manteniéndolo construyen algo que realmente vale la pena.',
    ],
    nextStep:
      'Hablemos por WhatsApp. Revisamos qué dimensión del próximo crecimiento podría introducir desorden en el sistema actual, y diseñamos cómo blindar esa dimensión antes de que llegue. En este nivel, el valor no está en corregir — está en anticipar.',
    whatsappMsg:
      'Hola Oscar, hice el diagnóstico y salí en Pasaste el techo. Me gustaría hablar contigo.',
  },
}

export const blockAnalysis = {
  estrategia: [
    'Tu punto más débil está en Estrategia. Esto significa que probablemente tienes operación real — puede que hasta tengas procesos y algunas herramientas trabajando — pero la dirección del negocio no está del todo clara, o está clara en tu cabeza pero no articulada en el sistema. Sabes que haces algo bien, pero te cuesta ponerlo en palabras. Tomas decisiones, pero algunas son más reactivas que planificadas. Y los indicadores que deberían guiarte, o no están definidos, o no los revisas con la disciplina que requieren.',
    'Este patrón es común en dueños que construyeron el negocio por intuición, capacidad de ejecución y trabajo duro. Esa fórmula funciona hasta cierto punto — pero deja de escalar cuando el negocio necesita que otras personas tomen decisiones alineadas sin tu presencia. Un equipo no puede ejecutar una estrategia que no existe con claridad. Una operación no puede optimizarse hacia un objetivo que no está definido. Y la tecnología no puede multiplicar una dirección que todavía no está resuelta.',
    'Antes de construir más estructura o implementar más tecnología, necesitas resolver esto. Porque cualquier sistema que construyas encima de una estrategia difusa va a amplificar la falta de claridad, no a resolverla. Vas a tener más operaciones, más personas, más herramientas — todas moviéndose en direcciones ligeramente distintas porque nunca hubo una dirección única definida. Y el costo de eso es enorme: no en dinero, sino en esfuerzo que no compone.',
    'El trabajo aquí es específico: articular con claridad hacia dónde va el negocio en los próximos 12-24 meses, qué diferenciador real tiene en el mercado, y qué 3 indicadores son los que realmente reflejan si estás moviéndote en esa dirección o no. Con eso resuelto, todo lo demás — estructura, tecnología, equipo — se construye con intención y en el orden correcto.',
  ],
  estructura: [
    'Tu punto más débil está en Estructura. Esto significa que el negocio depende demasiado de ti. Probablemente tienes visión clara — sabes hacia dónde va el negocio y por qué — y puede que hasta tengas herramientas tecnológicas implementadas. Pero los procesos clave, los criterios de decisión y los roles reales viven en tu cabeza, no en el sistema. Cuando alguien nuevo entra, tú les enseñas. Cuando hay una decisión importante, pasa por ti. Cuando algo falla, te llega a ti para resolverlo.',
    'Aquí es donde la mayoría de los dueños con negocios sólidos se estancan. Y lo que hace especialmente difícil este punto es que el trabajo de salir de él no se ve inmediatamente rentable. Documentar procesos, definir criterios de decisión, construir roles reales — todo eso toma tiempo y no genera ingresos directos el mes que lo haces. Por eso siempre parece que hay algo más urgente, y por eso la estructura se pospone indefinidamente.',
    "Pero el costo de no construirla es silencioso y acumulativo. Cada decisión que sigue pasando por ti es tiempo que no inviertes en el siguiente nivel del negocio. Cada proceso que solo tú sabes es un punto único de falla. Cada intento de delegar que no funcionó es una confirmación — falsa — de que 'nadie lo hace como tú'. La verdad es distinta: nadie puede hacerlo como tú porque no existe un sistema que les diga cómo. Les estás transfiriendo la tarea, pero no la claridad que la hace posible.",
    'La salida no es soltar y esperar. Es diseñar antes de soltar. Definir cómo se hace cada proceso clave. Establecer qué decisiones puede tomar cada rol sin consultarte. Crear los criterios que permiten que tu equipo actúe en tu ausencia con la misma dirección que actuarían contigo. Cuando esa estructura existe, delegar deja de ser un acto de fe — se convierte en la consecuencia natural de un sistema bien diseñado. Y tú puedes finalmente hacer el trabajo que solo tú puedes hacer.',
  ],
  tecnologia: [
    'Tu punto más débil está en Tecnología. Esto significa que probablemente tienes dirección y cierto nivel de estructura operativa, pero la forma en que la tecnología sostiene — o debería sostener — todo eso no está resuelta. Puede que tengas herramientas que nadie usa. Puede que la operación siga siendo mayormente manual cuando hay tareas que podrían automatizarse hace tiempo. Puede que hayas implementado tecnología por impulso, sin haber definido primero qué proceso exactamente querías mejorar — y el resultado fue más complejidad en lugar de menos.',
    'Este es un punto particularmente frustrante porque la tecnología está en todas partes hoy. Hay herramientas, automatizaciones, agentes de IA, integraciones. Y la sensación constante es que otros las están aprovechando mientras tú estás quedándote atrás. Pero la verdad es que la mayoría de los negocios que implementan tecnología sin criterio terminan peor que antes — con más sistemas que gestionar, más suscripciones que pagar, más fricción en lugar de menos.',
    "La tecnología no es buena ni mala. Es un multiplicador. Y como todo multiplicador, amplifica lo que ya tienes. Si tienes procesos claros, la tecnología los hace más rápidos y más escalables. Si tienes procesos confusos, la tecnología convierte la confusión en algo automático — y mucho más difícil de corregir. Por eso la pregunta correcta nunca es 'qué herramienta debería usar'. La pregunta correcta es 'qué proceso específico quiero mejorar, y qué problema exactamente estoy tratando de resolver'.",
    'Cuando entras con esa claridad, la tecnología correcta se vuelve obvia y la implementación deja de ser un proyecto interminable. El trabajo aquí no es aprender más tecnología. Es aplicar criterio para elegir cuál, cuándo y para qué. Una vez que ese criterio está resuelto, la tecnología hace exactamente lo que debería hacer: liberar tiempo, multiplicar resultados y permitir que el negocio funcione con menos dependencia de la presencia constante de alguien.',
  ],
}
